import { Table } from 'antd'
import styles from './AiTable.module.scss'
import clsx from 'clsx'
import { Square } from '../../../utility/square/Square'
import React from 'react'

interface AiTableProps {
  title: string
  data?: any[]
  columns?: any[]
}
export const AiTable = ({ title, data = [], columns = [] }: AiTableProps) => {
  return (
    <Square className={'w-full py-[12px] px-[24px]'}>
      <div className={'flex flex-col'}>
        <div className={'text-[20px] text-focus-500'}>{title}</div>
      </div>
      <Table
        className={clsx(styles.table)}
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    </Square>
  )
}
